import hdrm from '../../hdrm';
import site from '../../site';
import globals from '../../globals';
import {
  UPDATE_BOTH,
  UPDATE_LIVE_ONLY,
  UPDATE_STATIC_ONLY,
} from '../../hdrm/constants/update-strategies';
import actionTypes from '../constants/action-types';
import getStaticElement from '../accessors/get-static-element';
import getLiveElement from '../accessors/get-live-element';

const handleBulkSetChildrenPresenceAction = (action) => {
  const { containerId, childrenPresenceUpdates, options } = action.payload;
  const { strategy } = options;
  const staticElement = getStaticElement(containerId);
  const liveElement = getLiveElement(containerId);
  let newHTML;

  switch (strategy) {
    case UPDATE_STATIC_ONLY: {
      newHTML = hdrm.operations.bulkSetChildrenPresence(staticElement, childrenPresenceUpdates);
      break;
    }
    case UPDATE_BOTH: {
      hdrm.operations.bulkSetChildrenPresence(liveElement, childrenPresenceUpdates);
      newHTML = hdrm.operations.bulkSetChildrenPresence(staticElement, childrenPresenceUpdates);
      break;
    }
    case UPDATE_LIVE_ONLY: {
      hdrm.operations.bulkSetChildrenPresence(liveElement, childrenPresenceUpdates);
    }
  }

  return newHTML;
};

const setChildrenPresence = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.BULK_SET_CHILDREN_PRESENCE
      );

      actions.forEach((targetAction) => {
        handleBulkSetChildrenPresenceAction(targetAction);
      });

      next(action);

      break;
    }

    case actionTypes.SET_CHILDREN_PRESENCE: {
      const { containerId, childrenPresenceUpdate, globalsToUpdate, options } = action.payload;
      const { strategy } = options;
      const staticElement = getStaticElement(containerId);
      const liveElement = getLiveElement(containerId);
      let newHTML;

      switch (strategy) {
        case UPDATE_STATIC_ONLY: {
          newHTML = hdrm.operations.setChildrenPresence(staticElement, childrenPresenceUpdate);
          break;
        }
        case UPDATE_BOTH: {
          hdrm.operations.setChildrenPresence(liveElement, childrenPresenceUpdate);
          newHTML = hdrm.operations.setChildrenPresence(staticElement, childrenPresenceUpdate);
          break;
        }
        case UPDATE_LIVE_ONLY: {
          hdrm.operations.setChildrenPresence(liveElement, childrenPresenceUpdate);
        }
      }

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }

    case actionTypes.BULK_SET_CHILDREN_PRESENCE: {
      const { globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = handleBulkSetChildrenPresenceAction(action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default setChildrenPresence;
